import { useEffect, useState } from "react";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { API_BASE_URL } from "../../config";

const SeoFromApi = ({ pageType, slug }) => {
  const [seo, setSeo] = useState(null);

  /* ============================
     FETCH SEO DATA
  ============================ */
  useEffect(() => {
    if (!slug) return;

    let url = "";

    if (pageType === "blog") {
      url = `${API_BASE_URL}/public/blogs/${slug}/`;
    } else if (pageType === "org") {
      url = `${API_BASE_URL}/public/org/${slug}/`;
    }

    if (!url) return;

    axios
      .get(url)
      .then((res) => setSeo(res.data))
      .catch((err) => {
        console.error("SEO fetch failed", err);
        setSeo(null);
      });
  }, [pageType, slug]);

  if (!seo) return null;

  let title = seo.meta_title || seo.title || "";
  // Resolve CMS duplicate title collisions
  if (slug === "which-aviation-degree-is-right-for-you") {
    title = "Pilot vs Manager: Which Aviation Degree Is Right for You";
  } else if (slug === "the-best-aviation-schools-and-programs") {
    title = "How to Choose an Aviation School: Selection Guide";
  } else if (slug === "actual-imc-flying-instrument-students-guide") {
    title = "Actual IMC Flying: What Instrument Students Should Know";
  }

  let description = seo.meta_description || seo.description || "";
  if (description.length > 158) {
    description = description.slice(0, 155).replace(/\s+\S*$/, "") + "...";
  }
  const keywords = seo.meta_keywords || "";
  const robots = seo.robots || "index, follow, max-snippet:-1, max-image-preview:large";
  const ogTitle = seo.og_title || title;
  const ogDescription = seo.og_description || description;
  let canonicalUrl = seo.canonical_url;
  if (slug === "actual-imc-flying-instrument-students-guide") {
    canonicalUrl = "https://mhcockpit.com/blogs/imc-flying-instrument-students-real-clouds";
  } else if (!canonicalUrl) {
    canonicalUrl = typeof window !== "undefined"
      ? window.location.origin + window.location.pathname.replace(/\/+$/, "")
      : "";
  }

  return (
    <Helmet>
      {title && <title>{title}</title>}
      {title && <meta name="title" content={title} />}
      {description && <meta name="description" content={description} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}
      <meta name="robots" content={robots} />
      <meta httpEquiv="X-Robots-Tag" content={robots} />

      {/* Open Graph */}
      <meta property="og:title" content={ogTitle} />
      <meta property="og:description" content={ogDescription} />
      <meta property="og:type" content="article" />
      {seo.banner_image && <meta property="og:image" content={seo.banner_image} />}
      {canonicalUrl && <meta property="og:url" content={canonicalUrl} />}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={ogTitle} />
      <meta name="twitter:description" content={ogDescription} />
      {seo.banner_image && <meta name="twitter:image" content={seo.banner_image} />}

      {/* JSON-LD Structured Data */}
      {seo.blog_schema_markup && (
        <script type="application/ld+json">
          {typeof seo.blog_schema_markup === "string"
            ? seo.blog_schema_markup
            : JSON.stringify(seo.blog_schema_markup)}
        </script>
      )}
      {seo.faq_schema_markup && (
        <script type="application/ld+json">
          {typeof seo.faq_schema_markup === "string"
            ? seo.faq_schema_markup
            : JSON.stringify(seo.faq_schema_markup)}
        </script>
      )}
    </Helmet>
  );
};

export default SeoFromApi;
